<template>
  <div id="app">
    <page-header />
    <main role="main">
      <router-view />
    </main>
    <page-footer />
    <loading></loading>
  </div>
</template>

<script>
import PageHeader from '@/components/Common/PageHeader.vue'
import PageFooter from '@/components/Common/PageFooter.vue'

import '@/assets/js/bootstrap/bootstrap.min.css'
import '@/assets/js/fontawesome/css/fontawesome.min.css'
import '@/assets/js/ciaoyukit/css/ciaoyu.css'
import '@/assets/js/ciaoyukit/css/package.css'
import '@/assets/js/uDefault/css/uDefault.css'
import '@/assets/css/style.css'

export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter,
  },
}
</script>
